import InvoiceAppointmentHistory from "./InvoiceAppointmentHistory";
import InvoiceDepositPayments from "./InvoiceDepositPayments";
import { formatInvoiceCurrencyAmount } from "helpers/invoiceCurrency";
import { invoiceCurrency as resolveInvoiceCurrency, paymentCurrency } from "helpers/invoiceCurrency";
import { formatMoney as formatKnownMoney } from "helpers/money";
import InvoiceRefundHistory from "./InvoiceRefundHistory";
import { invoiceRefundBalance } from "./completedSaleRefund";
import { invoiceCreditRows } from "../../../sales/Invoice/invoiceCreditRows";
import { normalizeVoucherMoney } from "../../../../services/voucherContract";
import InvoiceDiscountBreakdown from "../../../sales/Invoice/InvoiceDiscountBreakdown";
import SubscriptionInvoiceTerms from "../../../sales/Invoice/SubscriptionInvoiceTerms";
import "./clientInvoiceLayout.css";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import config from "../../../../config"
import { TaxValueApi } from "store/slices/taxSlice";
import { ActiveBtnState, ClientInvoiceDetailApi, ClientInvoiceListViewApi, CompletedSaleDataForRefund, OpenClientInvoiceDetails, OpenStripeRefundCompletedSaleModal, RefundStripeToken, SaleActivityApi } from "store/slices/clientinvoiceSlice";
import { saleUpdateApi, ViewSaleDetailInvoiceApi } from "store/slices/saleSlice";
import { useTranslation } from "react-i18next";
import { buildClientInvoiceDisplay } from "./clientInvoiceDisplay";
import { clientInvoicePaymentRows, clientInvoiceRefundRows } from "./clientInvoicePaymentRows";
import InvoiceActivityTimeline from "./InvoiceActivityTimeline";
import { usercheckAccess } from "helpers/Functions";
import InvoiceEditor from "../../../sales/Invoice/InvoiceEditor";
import { invoiceAppointmentMeta, invoiceServiceMeta } from "../../../sales/Invoice/invoiceAppointmentMeta";

const ClientPaidInvoice = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useState("");
  const [TotalAudCosts, setTotalAudCosts] = useState(0);

  const [openModal, setOpenModal] = useState(false);
  const [editInvoice, setEditInvoice] = useState(null);
  const [editLoadError, setEditLoadError] = useState("");
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  const rightDrawerOpened = useSelector((state) => state.clientinvoice.isOpenClientInvoiceDetailsTab);
  const isSaleCompletedData = useSelector(
    (state) => state.clientinvoice.isClientInvoiceDetail || state.clientinvoice.isClientInvoiceDetailsTabData
  );
  const invoiceCurrency = resolveInvoiceCurrency(isSaleCompletedData);
  const saleId = isSaleCompletedData?.id;
  const clientId = isSaleCompletedData?.client_id || isSaleCompletedData?.client?.id;
  const saleActivity = useSelector((state) => state.clientinvoice.saleActivity || {});
  const invoiceDisplay = buildClientInvoiceDisplay(isSaleCompletedData || {}, {
    taxPercentage: useSelector((state) => state.tax.isTaxValue)?.percentage,
  });
  useSelector(state => state.clientinvoice.isTaxAmountClientPaidInvoice);
  useSelector(state => state.clientinvoice.isClientMemberShipTotalPay);
  useSelector(state => state.clientinvoice.totalServiceCosts);
  let TaxInvoiceNumber = invoiceDisplay.invoiceNumber;
  const formattedInvoiceDate = invoiceDisplay.invoiceDate;
  const ClientData = isSaleCompletedData && isSaleCompletedData.client;
  let client_first_name = isSaleCompletedData && isSaleCompletedData.client && ClientData.first_name;
  let client_last_name = isSaleCompletedData && isSaleCompletedData.client && ClientData.last_name;
  const clientFullName = invoiceDisplay.clientName || (client_first_name ? client_first_name + " " + client_last_name : "");
  const CartData = isSaleCompletedData && isSaleCompletedData.cart;
  void (isSaleCompletedData && isSaleCompletedData.total_pay);
  const payments = Array.isArray(isSaleCompletedData?.payment) ? isSaleCompletedData.payment : [];
  // let tax = taxPercentage && total_pay ? total_pay / taxPercentage : "";
  // let memberShipTax = taxPercentage && isClientMemberShipTotalPay ? isClientMemberShipTotalPay / taxPercentage : "";
  const depositRefund = clientInvoiceRefundRows(payments).reduce((sum, payment) => sum + payment.amount, 0);
  const depositBalance = invoiceRefundBalance(isSaleCompletedData);
  void (CartData && CartData.length > 0 ? CartData.filter(item => item.type === "Service") : []);
  const singlePaymentSale = clientInvoicePaymentRows(payments);


  const appliedvoucherto = isSaleCompletedData && isSaleCompletedData.appliedvoucherto ? isSaleCompletedData.appliedvoucherto : "";
  const saleStatus = isSaleCompletedData?.status ?? '';
  // const BalanceViews = (totalServiceCosts || 0) - (salePaid || 0) - (depositPaid || 0);
  // const depositBalance = depositPaid >= depositRefund ? depositPaid + depositRefund : 0;

  useEffect(() => {
    dispatch(TaxValueApi());
  }, []);

  useEffect(() => {
    if (rightDrawerOpened && saleId) {
      dispatch(SaleActivityApi({ id: saleId }));
    }
  }, [dispatch, rightDrawerOpened, saleId, currentUser]);

  useEffect(() => {
    if (!rightDrawerOpened || !saleId || isSaleCompletedData?.status !== "Paid" || !usercheckAccess("edit_invoice", currentUser)) return;
    let active = true;
    setEditInvoice(null);
    setEditLoadError("");
    dispatch(ViewSaleDetailInvoiceApi({ id: saleId })).unwrap()
      .then((detail) => { if (active) setEditInvoice(detail); })
      .catch(() => { if (active) setEditLoadError("Unable to load invoice editing details."); });
    return () => { active = false; };
  }, [dispatch, rightDrawerOpened, saleId, isSaleCompletedData?.status, currentUser]);

  useEffect(() => {
    let totalCost = 0;

    if (CartData && CartData.length > 0) {
      CartData.forEach(item => {
        let cost = 0;

        if (item && item?.type) {
          switch (item.type) {
            case "Membership":
            case "Product":
            case "Subscription":
            case "Service":
              cost = item.cost ? parseFloat(item.cost) : 0;
              break;
            case "OneOffVoucher":
            case "Voucher":
              cost = item.voucherto && item.voucherto.amount ? parseFloat(item.voucherto.amount) : 0;
              break;
            case "Appointment":
            case "AddOnServices":
            case "AddAnotherServices":
              cost = item.cost ? parseFloat(item.cost) : 0;
              break;
            default:
              cost = 0;
          }
          totalCost += cost;
        }
      });

    if (!totalCost && invoiceDisplay.total) totalCost = invoiceDisplay.total;
    }

    setTotalAudCosts(totalCost);
  }, [CartData, invoiceDisplay.total]);

  return (
    <div className={"drawer client-invoice-drawer " + rightDrawerOpened}>
      <div className="drawer-wrp position-relative">
        <div className="drawer-header">
          <h2 className="mb-4 pe-md-5 pe-3">Invoice</h2>
          <a href="#" className="close" onClick={() => {
            dispatch(OpenClientInvoiceDetails(""))
          }}>
            <img src={config.imagepath + "close-icon.svg"} alt="" />
          </a>
        </div>
        <hr />
        <div className="drawer-body d-flex flex-wrap">
          {openModal && (
            <>
              <div className={openModal ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: openModal ? "block" : "none" }}>
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-body pb-0">
                      <div className="p-3">
                        <h5 className="mb-3 fw-semibold text-dark">{t("Refund Warning")}</h5>
                        <p className="mb-3 fw-semibold">{t("Full Amount is Already Refunded For This Appointments")}</p>
                      </div>
                      <div className="row mt-3 bg-cream p-4 justify-content-center">
                        <div className="col-6">
                          <button className="btn btn-primary w-100" type="button" onClick={() => {
                            setOpenModal(false);
                          }}>
                            {t("OK")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {openModal && <div className="modal-backdrop show"></div>}
            </>
          )}
          <ul className="sale-comlete-data list-unstyled">
            <li className="">
            <h5 className="mb-1 fw-semibold">Tax Invoice {TaxInvoiceNumber}</h5>
              <p className="mb-0">Invoice status: {invoiceDisplay.status || "Unavailable"}</p>
              {["Cancelled", "Void"].includes(saleStatus) && <p>No payment is requested for this cancelled invoice.</p>}
              <p className="mb-0">{formattedInvoiceDate}</p>
              {saleId && isSaleCompletedData?.status === "Paid" && editLoadError && <div role="alert">
                {editLoadError}
                <button type="button" className="btn btn-link btn-sm" onClick={() => {
                  setEditLoadError("");
                  dispatch(ViewSaleDetailInvoiceApi({ id: saleId })).unwrap()
                    .then(setEditInvoice)
                    .catch(() => setEditLoadError("Unable to load invoice editing details."));
                }}>Retry loading invoice editor</button>
              </div>}
              {saleId && isSaleCompletedData?.status === "Paid" && editInvoice && <InvoiceEditor
                invoice={editInvoice}
                canEdit={usercheckAccess("edit_invoice", currentUser)}
                onSave={(values) => dispatch(saleUpdateApi(values)).unwrap()}
                onChanged={async () => {
                  const action = await dispatch(ViewSaleDetailInvoiceApi({ id: saleId }));
                  if (action.meta.requestStatus === "fulfilled") setEditInvoice(action.payload);
                  else setEditLoadError("Invoice saved, but the refreshed editing details could not be loaded.");
                  dispatch(ClientInvoiceDetailApi({ client_id: clientId, id: saleId }));
                  dispatch(ClientInvoiceListViewApi({ client_id: clientId }));
                  dispatch(SaleActivityApi({ id: saleId }));
                }}
              />}
            </li>
            <li className="border-top my-3 pt-3">
              <label>
                Invoice to:
                <label>
                  <h6 className="mb-0">{clientFullName}</h6>
                </label>
              </label>
            </li>
            {CartData && CartData.length > 0 ? (
              Object.keys(CartData).map((item, i) => {
                let ServiceName = CartData[item] && CartData[item].services && CartData[item].services.name;
                let ServiceCosts = CartData[item] && CartData[item].cost;

                // let AddOnServiceData = CartData[item] && CartData[item].appointment && CartData[item].appointment.addonservices.filter(() => CartData[item] && CartData[item].type && CartData[item].type == "Appointment");
                let AddOnServiceData = CartData[item] && CartData[item].addonaddanotherservices && CartData[item].addonaddanotherservices.length > 0 ? CartData[item].addonaddanotherservices : [];


                let membershipCosts = CartData[item] && CartData[item].type && CartData[item].type === "Membership" && CartData[item].cost ? CartData[item].cost : 0;
                let oneoffvoucherCosts = CartData[item]?.type === "OneOffVoucher" ? normalizeVoucherMoney(CartData[item].cost) : "";
                let voucherCosts = CartData[item]?.type === "Voucher" ? normalizeVoucherMoney(CartData[item].cost) : "";
                let SubscriptionCosts = CartData[item] && CartData[item].type && CartData[item].type === "Subscription" && CartData[item].cost ? CartData[item].cost : 0;

                let productCost = CartData[item] && CartData[item].type && CartData[item].type === "Product" && CartData[item].cost ? CartData[item].cost : 0;
                void (CartData[item] && CartData[item].type && CartData[item].type === "Service" && CartData[item].cost ? CartData[item].cost : 0);

                let voucherName = CartData[item] && CartData[item].type && CartData[item].type === "Voucher" && CartData[item].voucherto && CartData[item].voucherto.first_name && CartData[item].voucherto.last_name ? CartData[item].voucherto.first_name + " " + CartData[item].voucherto.last_name : "";
                let SubscriptionName = CartData[item]?.subscription_terms?.name || (CartData[item] && CartData[item].type && CartData[item].type === "Subscription" && CartData[item].subscription && CartData[item].subscription.name ? CartData[item].subscription.name : "");
                let oneoffvoucherName = CartData[item] && CartData[item].type && CartData[item].type === "OneOffVoucher" && CartData[item].voucherto && CartData[item].voucherto.first_name && CartData[item].voucherto.last_name ? CartData[item].voucherto.first_name + " " + CartData[item].voucherto.last_name : "";
                let membershipName = CartData[item] && CartData[item].type && CartData[item].type === "Membership" && CartData[item].membership && CartData[item].membership.name ? CartData[item].membership.name : "";
                let productName = CartData[item] && CartData[item].type && CartData[item].type === "Product" && CartData[item].products && CartData[item].products.name ? CartData[item].products.name : "";
                let product_staff_name = CartData[item] && CartData[item].type && CartData[item].type === "Product" && CartData[item].staff && (CartData[item].staff.first_name && CartData[item].staff.last_name) ? CartData[item].staff.first_name + " " + CartData[item].staff.last_name : "";
                let dateOfInvoiced = CartData[item] && CartData[item].created_at ? moment(CartData[item].created_at, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ").format("DD/MM/YYYY") : "";
                let clientsubscriptionplan = CartData[item] && CartData[item].type && CartData[item].type === "Subscription" && CartData[item]?.clientsubscriptionplan && CartData[item]?.clientsubscriptionplan.length > 0 ? CartData[item]?.clientsubscriptionplan[0] : "";
                let commencement_date = clientsubscriptionplan && clientsubscriptionplan?.commencement_date ? moment(clientsubscriptionplan?.commencement_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY") : "";
                let custom_first_amount = CartData[item] && CartData[item].type && CartData[item].type === "Subscription" && clientsubscriptionplan?.one_off_payments && clientsubscriptionplan?.one_off_payments == 1 && clientsubscriptionplan?.one_off_amount ? clientsubscriptionplan?.one_off_amount : "";
                let client_subscription_staff = CartData[item] && CartData[item].type && CartData[item].type === "Subscription" && CartData[item].staff && (CartData[item].staff.first_name && CartData[item].staff.last_name) ? `${CartData[item].staff.first_name} ${CartData[item].staff.last_name}` : "";
                let qty = CartData[item].qty;

                return (
                  <React.Fragment key={i}>
                    {CartData[item] && CartData[item].type && (CartData[item].type === "Appointment" || CartData[item].type === "AddOnServices" || CartData[item].type === "AddAnotherServices") ? (
                      <>
                        <li className="border-top my-3 pt-3">
                          <div className="row gx-1 justify-content-between">
                            <div className="col-10">
                              <label htmlFor="">{ServiceName ? ServiceName : ""}</label>
                              <h6 className="mb-1">{invoiceServiceMeta(CartData[item], isSaleCompletedData?.invoice_date || isSaleCompletedData?.invoicedate)}</h6>
                              <span>Quantity: 1</span>
                            </div>
                            <label className="col-2 text-end">{formatTenantMoney(ServiceCosts ? ServiceCosts : "0", invoiceCurrency)}</label>
                          </div>
                        </li>
                      </>
                    ) : ""}
                    {CartData[item] && CartData[item].type && CartData[item].type === "Service" ? (
                      <>
                        <li className="border-top my-3 pt-3">
                          <div className="row gx-1 justify-content-between">
                            <div className="col-10">
                              <label htmlFor="">{ServiceName ? ServiceName : ""}</label>
                              <h6 className="mb-1">{invoiceServiceMeta(CartData[item], isSaleCompletedData?.invoice_date || isSaleCompletedData?.invoicedate)}</h6>
                              <span>Quantity: 1</span>
                            </div>
                            <label className="col-2 text-end">{formatTenantMoney(ServiceCosts ? ServiceCosts : "0", invoiceCurrency)}</label>
                          </div>
                        </li>
                      </>
                    ) : ""}
                    {CartData[item] && CartData[item].type && CartData[item].type === "Membership" ? (
                      <>
                        <li className="border-top my-3 pt-3">
                          <div className="row gx-1 justify-content-between">
                            <div className="col-10">
                              <label htmlFor="">{membershipName ? membershipName : ""}</label>
                              <h6 className="mb-1">{dateOfInvoiced}</h6>
                              <span>Quantity: 1</span>
                            </div>
                            <label className="col-2 text-end">{formatTenantMoney(membershipCosts ? membershipCosts : "0", invoiceCurrency)}</label>
                          </div>
                        </li>
                      </>
                    ) : ""}
                    {CartData[item] && CartData[item].type && CartData[item].type === "Voucher" ? (
                      <>
                        <li className="border-top my-3 pt-3">
                          <div className="row gx-1 justify-content-between">
                            <div className="col-10">
                              <label htmlFor="">{voucherName ? voucherName : ""}</label>
                              <div>{t("Value")}: {normalizeVoucherMoney(CartData[item].voucherto?.amount) === "" ? "—" : `${formatTenantMoney(CartData[item].voucherto?.amount, invoiceCurrency)}`}</div>
                              <h6 className="mb-1">{dateOfInvoiced}</h6>
                              <span>Quantity: 1</span>
                            </div>
                            <label className="col-2 text-end">{voucherCosts === "" ? "—" : `${formatTenantMoney(voucherCosts, invoiceCurrency)}`}</label>
                          </div>
                        </li>
                      </>
                    ) : ""}
                    {CartData[item] && CartData[item].type && CartData[item].type === "OneOffVoucher" ? (
                      <>
                        <li className="border-top my-3 pt-3">
                          <div className="row gx-1 justify-content-between">
                            <div className="col-10">
                              <label htmlFor="">{oneoffvoucherName ? oneoffvoucherName : ""}</label>
                              <div>{t("Value")}: {normalizeVoucherMoney(CartData[item].voucherto?.amount) === "" ? "—" : `${formatTenantMoney(CartData[item].voucherto?.amount, invoiceCurrency)}`}</div>
                              <h6 className="mb-1">{dateOfInvoiced}</h6>
                              <span>Quantity: 1</span>
                            </div>
                            <label className="col-2 text-end">{oneoffvoucherCosts === "" ? "—" : `${formatTenantMoney(oneoffvoucherCosts, invoiceCurrency)}`}</label>
                          </div>
                        </li>
                      </>
                    ) : ""}
                    {CartData[item] && CartData[item].type && CartData[item].type === "Product" ? (
                      <>
                        <li className="border-top my-3 pt-3">
                          <div className="row gx-1 justify-content-between">
                            <div className="col-10">
                              <label htmlFor="">{productName ? productName : ""}</label>
                              {product_staff_name ? <p className="mb-0 text-dark">{product_staff_name}</p> : ""}
                              <h6 className="mb-1">{dateOfInvoiced}</h6>
                              <span>Quantity: {qty}</span>
                            </div>
                            <label className="col-2 text-end">{formatTenantMoney(productCost ? parseFloat(productCost) * parseInt(qty) : "0", invoiceCurrency)}</label>
                          </div>
                        </li>
                      </>
                    ) : ""}
                    {CartData[item] && CartData[item].type && CartData[item].type === "Subscription" ? (
                      <>
                        <li className="border-top my-3 pt-3">
                          <div className="row gx-1 justify-content-between">
                            <div className="col-10">
                              <label htmlFor="">{SubscriptionName ? SubscriptionName : ""}</label>
                            </div>
                            <label className="col-2 text-end">{formatTenantMoney(SubscriptionCosts ? SubscriptionCosts : 0, invoiceCurrency)}</label>
                            {client_subscription_staff && <div className="col-10">
                              <label htmlFor="" className="fw-normal">With {client_subscription_staff}</label>
                            </div>}
                            <SubscriptionInvoiceTerms terms={CartData[item].subscription_terms} />
                            {custom_first_amount ? (
                              <>
                                <div className="col-10">
                                  <label htmlFor="">Custom First Amount</label>
                                </div>
                                <label className="col-2 text-end">{formatTenantMoney(custom_first_amount ? custom_first_amount : 0, invoiceCurrency)}</label>
                              </>
                            ) : ""}
                            {commencement_date ? (
                              <>
                                <div className="col-8">
                                  <label htmlFor="">CommenceMent Date</label>
                                </div>
                                <label className="col-4 text-end">{commencement_date ? commencement_date : ""}</label>
                              </>
                            ) : ""}
                            <span>Quantity: 1</span>
                          </div>
                        </li>
                      </>
                    ) : ""}
                    {AddOnServiceData && AddOnServiceData.length > 0 ? Object.keys(AddOnServiceData).map((item, i) => {

                      let serviceNames = AddOnServiceData[item] && AddOnServiceData[item].service && AddOnServiceData[item].service.name;

                      let ServicesCosts = AddOnServiceData[item] && AddOnServiceData[item].cost;
                      return (
                        <React.Fragment key={i}>
                          <li className="border-top my-3 pt-3">
                            <div className="row gx-1 justify-content-between">
                              <div className="col-10">
                                <label htmlFor="">{serviceNames ? serviceNames : ""}</label>
                                <h6 className="mb-1">{invoiceAppointmentMeta(AddOnServiceData[item])}</h6>
                                <span>Quantity: 1</span>
                              </div>
                              <label className="col-2 text-end">{formatTenantMoney(ServicesCosts ? ServicesCosts : "0", invoiceCurrency)}</label>
                            </div>
                          </li>
                        </React.Fragment>
                      )
                    }) : null}

                  </React.Fragment>
                )
              })
            ) : null}

            <InvoiceDiscountBreakdown invoice={isSaleCompletedData} />
            {currentUser && currentUser.salon && currentUser.salon.tax && currentUser.salon.tax.name === "Non-GST" ? "" : (
              <li className="border-top my-3 pt-3">
                <div className="row gx-1 justify-content-between">
                  <div className="col-10">
                    <h6 className="mb-0">Includes GST of</h6>
                  </div>
                  {/* <h6 className="mb-0 col-2 text-end">${memberShipTax ? parseFloat(memberShipTax).toFixed(2) : isTaxAmountClientPaidInvoice ? isTaxAmountClientPaidInvoice : "0"}</h6> */}
                  <h6 className="mb-0 col-2 text-end">{formatTenantMoney(invoiceDisplay.gst.toFixed(2), invoiceCurrency)}</h6>
                </div>
              </li>
            )}
            <li className="border-top my-3 pt-3">
              <div className="row gx-1 justify-content-between">
                <label className="mb-0 col-10">{t("Total")} {invoiceCurrency || ""}</label>
                {/* <label className="mb-0 col-2 text-end">${totalServiceCosts ? totalServiceCosts : isClientMemberShipTotalPay ? isClientMemberShipTotalPay : "0"}</label> */}
                <label className="mb-0 col-2 text-end">
                  {formatTenantMoney((isSaleCompletedData?.discount_code ? invoiceDisplay.total : (TotalAudCosts || invoiceDisplay.total || 0)).toFixed(2), invoiceCurrency)}
                </label>
              </div>
            </li>
            {invoiceDisplay.note ? (
              <li className="border-top my-3 pt-3">
                <div className="row gx-1 justify-content-between">
                  <div className="col-12">
                    <h6 className="mb-0">{t("Note")}</h6>
                    <span className="text-break">{invoiceDisplay.note}</span>
                  </div>
                </div>
              </li>
            ) : null}
            {invoiceCreditRows(isSaleCompletedData).map(([label, amount]) => (
              <li key={label} className="border-top my-3 pt-3">
                <div className="row gx-1 justify-content-between">
                  <div className="col-10"><h6 className="mb-0">{t(label)}</h6></div>
                  <h6 className="mb-0 col-2 text-end">{formatTenantMoney(amount.toFixed(2), invoiceCurrency)}</h6>
                </div>
              </li>
            ))}
            {isSaleCompletedData && isSaleCompletedData.voucher_discount && parseFloat(isSaleCompletedData.voucher_discount) > 0 ? (
              <li className="border-top my-3 pt-3">
                <div className="row gx-1 justify-content-between">
                  <div className="col-10">
                    <label className="mb-0 fw-normal col-10">
                      {appliedvoucherto.voucher ? appliedvoucherto.voucher.name : "One-Off Vocuher"} <span className="ms-2 mb-0 btn btn-outline-success p-1">{appliedvoucherto.code} </span>
                    </label>
                    {appliedvoucherto && appliedvoucherto.service && appliedvoucherto.service.name ? (
                      <label className="mb-0 fw-normal col-10">
                        Service Included : {appliedvoucherto.service.name}
                      </label>
                    ) : ""}
                  </div>
                  <h6 className="mb-0 col-2 text-end">{formatTenantMoney(isSaleCompletedData.voucher_discount ? isSaleCompletedData.voucher_discount : 0, invoiceCurrency)}</h6>
                </div>
              </li>
            ) : null}
            {singlePaymentSale && singlePaymentSale.length > 0 && (saleStatus !== 'Schedule') ? (
              <>
                {singlePaymentSale.map((item, i) => {
                  const paidByStatusSale = item.method;
                  return (
                    <React.Fragment key={i}>
                      <li className="border-top my-3 pt-3">
                        <div className="row gx-1 justify-content-between">
                          <div className="col-10">
                            <h6 className="mb-0">{`Sale Paid By ${paidByStatusSale}`} {item.status && <strong>{item.status}</strong>}</h6>
                          </div>
                          <h6 className="mb-0 col-2 text-end">{formatTenantMoney(item.amount, paymentCurrency(item, invoiceCurrency))}</h6>
                        </div>
                      </li>
                    </React.Fragment>
                  )
                })}
              </>
            ) : ""}
            <InvoiceAppointmentHistory appointments={isSaleCompletedData?.appointments} timezone={isSaleCompletedData?.salon?.timezone} />
            <InvoiceDepositPayments payments={payments} currency={invoiceCurrency} />
            <InvoiceRefundHistory currency={invoiceCurrency} payments={payments}/>
            <li className="border-top my-3 pt-3">
              <div className="row gx-1 justify-content-between">
                <label className="mb-0 fw-normal col-10">{["Cancelled", "Void"].includes(saleStatus) ? "Recorded balance" : "Balance"}</label>
                {/* below condition checks NAN and negative than zero */}
                    <label className="mb-0 fw-normal col-2 text-end">{invoiceCurrency ? (invoiceDisplay.balance || 0).toFixed(2) : t("Unavailable until currency is confirmed")}</label>
                {/* <label className="mb-0 fw-normal col-2 text-end">${(TotalAudCosts || 0) - (salePaid || 0) - (depositPaid || 0)}</label> */}
              </div>
            </li>
            {depositRefund && depositRefund > 0 ? (
              <>
                <li className="border-top my-3 pt-3">
                  <div className="row gx-1 justify-content-between">
                    <label className="mb-0 fw-normal col-10">Refund issued</label>
                    <label className="mb-0 fw-normal col-2 text-end">{formatTenantMoney(depositRefund ? depositRefund : 0, invoiceCurrency)}</label>
                  </div>
                </li>
              </>
            ) : ""}
            {saleId && <li className="border-top my-3 pt-3">
              <h6>{t("Activity")}</h6>
              <InvoiceActivityTimeline
                activity={saleActivity[saleId]?.entries || []}
                status={saleActivity[saleId]?.status}
                onRetry={() => dispatch(SaleActivityApi({ id: saleId }))}
              />
            </li>}
            {saleStatus === "Paid" && invoiceDisplay.canRefund ? (
              <li className="border-top my-3 pt-3">
                <div className="row gx-1 justify-content-between">
                  <button
                    type="button"
                    className="btn btn-apricots cursor-pointer"
                    onClick={() => {
                      if (depositBalance && depositBalance > 0) {
                        dispatch(RefundStripeToken(""));
                        dispatch(ActiveBtnState(""));
                        dispatch(CompletedSaleDataForRefund({ isSaleCompletedData: isSaleCompletedData, appointmentsArray: isSaleCompletedData && isSaleCompletedData.appointments && isSaleCompletedData.appointments.length > 0 ? isSaleCompletedData.appointments[0] : [], isdepositBalance: depositBalance ? depositBalance : 0, FullCartData: isSaleCompletedData && isSaleCompletedData.cart && isSaleCompletedData.cart.length > 0 ? isSaleCompletedData.cart : [] }));
                        dispatch(OpenStripeRefundCompletedSaleModal("open"));
                      } else {
                        setOpenModal(true)
                      }
                    }}
                  >
                    {t("Refund")}
                  </button>
                </div>
              </li>
            ) : ""}
          </ul>
        </div>
      </div>
    </div >
  )
};

export default ClientPaidInvoice;

function formatTenantMoney(value, currency) {
  return currency ? formatKnownMoney(value, currency) : formatInvoiceCurrencyAmount(value, "");
}
